export const loginApiPath = 'cashier/login';

export const merchantApiPath = 'mobile/foodbeverage/merchant';
export const listmenuApiPath = 'mobile/v4/foodbeverage/listing';
export const listMenuVideoApiPath = 'mobile/rand/listing';
export const merchantFeeInfoApiPath = 'mobile/tax';
export const merchantCheckApiPath = 'mobile/check/dinein';

export const kioskCheckoutPath = 'kios/order/create';